import React, { useState } from "react";
import PromoSection from "./home/PromoSection";
import CallToAction from "./home/CallToAction";
import Services from "./home/Services";
import PricingSection from "./home/PricingSection";
import FeatureSection from "./home/FeatureSection";
import SupportSection from "./home/SupportSection";
import ReviewSection from "./home/ReviewSection";
import OurBlogSection from "./home/OurBlogSection";
import ClientSection from "./home/ClientSection";
import NetworkMapSection from "./home/NetworkMapSection";
import HeroSection from "./home/HeroSection";
import {useForm} from "react-hook-form";

const Home = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [emailError, setEmailError] = useState(null)
    const [backError, setBackError] = useState(null)

    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        shouldFocusError: true
        }
    );

    const onSubmit = async (data) => {
        try {
            const response = await fetch(`${apiUrl}/preregistration`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if(result.error){
                if(result.error.email){
                    setEmailError(result.error.email.join(','))
                }else{
                    setBackError(result.error)
                }
            }else{
                reset()
                alert(result.message)
            }
        } catch (error) {
            console.log(error)
            console.error("Error sending email:", error);
            alert("Failed to send email.");
        }
    };

    return (
        <>
            <HeroSection/>

            <section className="position-relative zindex-2">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-9 col-lg-8 col-12">
                            <div className="domain-search-wrap border gray-light-bg">
                                <h4 className="text-center">Looking For Domain Name?</h4>
                                {backError ? <div className="form-level-error">{backError}</div> : null}

                                <form onSubmit={handleSubmit(onSubmit)} className="domain-search-form my-4">

                                    <input
                                        {...register('email', {
                                            required: { value: true, message: 'Email is required' },
                                            patern: {
                                                value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/,
                                                message: 'Oops! It seems like there\'s an issue with your email format. Please double-check.',
                                            },
                                        })}
                                        className={`form-control ${(errors?.email || emailError) && 'parsley-error'}`}
                                        onChange={(e) => {
                                            setEmailError(null);
                                            setBackError(null);
                                        }}
                                        id="preregistration-email"
                                        placeholder="your email address"
                                        type="email"
                                    />
                                    {errors?.email &&
                                        <ul className="parsley-errors-list filled">
                                            <li className="parsley-required">{errors?.email.message}</li>
                                        </ul>
                                    }
                                    { emailError &&
                                        <ul className="parsley-errors-list filled">
                                            <li className="parsley-required"> Email {emailError}</li>
                                        </ul>
                                    }

                                    <div className="select-group">
                                        <button type="submit" className="btn btn-primary"><i
                                            className="fas fa-search pe-1"></i> Search
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <PromoSection/>
            <CallToAction/>
            <Services/>
            <PricingSection/>
            <FeatureSection/>
            <SupportSection/>
            <NetworkMapSection/>
            <ReviewSection/>
            <OurBlogSection/>
            <ClientSection/>
        </>
    );
};

export default Home;
